export default "__VITE_ASSET__cR3FpXjZ__"